<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>心情配置</span>
          <el-button v-permisaction="['config:slotTestCfg:add']" type="primary" size="mini" style="margin-left: 16px;" @click="edit(formDataBak)">新增</el-button>
        </div>

        <el-table :data="tableData" border stripe>
          <el-table-column prop="name" label="名称">
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
            </template>
          </el-table-column>

          <el-table-column v-for="(t, idx) in title" :key="idx" :label="t">
            <template slot-scope="scope">
              <span>{{ getMood(scope.row.config, idx) }}</span>
            </template>
          </el-table-column>

          <el-table-column>
            <template slot-scope="scope">
              <el-button v-permisaction="['config:slotTestCfg:add']" type="text" size="small" @click="edit(scope.row)">编辑</el-button>
              <el-link v-permisaction="['config:slotTestCfg:del']" :underline="false" style="margin-left: 5px" type="danger" size="small" @click="del(scope.row.id)">删除</el-link>
            </template>
          </el-table-column>
        </el-table>
      </el-card>

      <el-drawer
        title="配置"
        :visible.sync="drawer"
        size="580px"
        :before-close="handleClose"
      >
        <el-form ref="formData" :inline="true" :rules="rules" :model="formData" label-width="120px">
          <el-form-item label="名称" prop="group">
            <el-input v-model="formData.name" placeholder="名称" />
          </el-form-item>
          <el-row v-for="(item, index) in formData.config" :key="index">
            <el-form-item label="事件类型" prop="type">
              <el-select v-model="item.type" disabled placeholder="请选择类型" @change="v=>typeChange(v,index)">
                <el-option v-for="(item, index) in selectType" :key="index" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-button type="primary" style="margin-left: 16px;" @click="drawerArr[index].visible = true">
              配置
            </el-button>

            <el-drawer
              title="心情配置"
              :visible.sync="drawerArr[index].visible"
              direction="rtl"
              :before-close="d=>handleClose2(d, index)"
              size="520px"
              append-to-body
            >
              <el-form :inline="true">
                <el-row v-for="(c, idx) in item.event" :key="idx">
                  <el-form-item label="事件" prop="type">
                    <el-select v-model="c.type" style="width: 150px" disabled placeholder="请选择类型">
                      <el-option v-for="(t, k) in chessType" :key="k" :label="t.label" :value="t.value" />
                    </el-select>
                  </el-form-item>
                  <el-form-item label="值" prop="value">
                    <el-input v-model="c.value" placeholder="值" />
                  </el-form-item>
                </el-row>
              </el-form>
            </el-drawer>

            <!--            <el-form-item style="margin-left: 15px">-->
            <!--              <el-button type="danger" @click="delCfg(index)">删除</el-button>-->
            <!--            </el-form-item>-->
          </el-row>
          <el-form-item style="width:100%;margin-top:50px;text-align: center">
            <el-button v-if="formData.config.length <=0" type="primary" @click="addCfg">+</el-button>
            <el-button v-if="formData.config.length > 0" type="primary" @click="onSubmit()">保存</el-button>
          </el-form-item>
        </el-form>
      </el-drawer>

      <el-drawer
        title="用户数据"
        :visible.sync="drawerUser"
        :with-header="false"
        size="800px"
      >
        <template>
          <el-table
            :data="tableUserData"
            border
            style="width: 100%"
          >
            <el-table-column
              prop="uid"
              label="用户ID"
              width="180"
            />
            <el-table-column
              prop="level"
              label="建筑等级"
              width="180"
            />
            <el-table-column
              prop="spins"
              label="消耗体力"
              width="180"
            />
            <el-table-column
              prop="coin"
              label="消耗金币"
            />
          </el-table>
        </template>
      </el-drawer>
      <pagination
        v-show="total>0"
        background
        :page.sync="queryParams.pageIndex"
        :limit.sync="queryParams.pageSize"
        :total="total"
        @pagination="getTables"
      />
    </template>
  </BasicLayout>
</template>

<script>
import { getChessBoardType } from '@/api/config/slot'
import {
  delSlotTestCfgList,
  getSlotTestCfgList,
  getSlotTestType,
  updateSlotTestCfgCfg
} from '@/api/config/slot-test'

export default {
  name: 'SlotTest',
  data() {
    return {
      title: [
        '打/偷', '灯泡', '金币1', '金币2', '金币3', '金币4', '金币5',
        '金币6', '金币7', '金币8', '骰子点数', '随机卡', '损失收入(罚款)', '飞艇',
        '起点收入', '社交奖励', '损失收入', '免费商店', '水管'
      ],
      drawerArr: [{ visible: false }],
      selectType: [],
      testAct: [
        { label: '棋盘走格子', value: 1 },
        { label: '建造', value: 2 }
        // { label: '收集活动', value: 3 },
        // { label: '锦标赛活动', value: 4 }
      ],
      outAct: [
        { label: '消耗体力', value: 1 },
        { label: '消耗金币', value: 2 },
        { label: '玩家等级', value: 3 }
      ],
      total: 0,
      tableData: [],
      loading: false,
      drawer: false,
      drawerUser: false,
      drawerCfg: false,
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      chessType: [],
      tableUserData: [],
      formDataBak: {
        id: 0,
        name: '',
        config: []
      },
      formData: {
        id: 0,
        name: '',
        config: []
      },
      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.getTables()
    this.getChessBoardType()
    this.getType()
  },
  methods: {
    typeChange(val, index) {
      console.log('val', val)
      this.formData.config[index].event = []
      switch (val) {
        case 1:
          this.formData.config[index].event.push({
            type: 1,
            value: 1
          })
          this.formData.config[index].event.push({
            type: 2,
            value: 1
          })

          break

        case 3:
          this.formData.config[index].event.push(
            { type: 13, value: 1 },
            { type: 14, value: 1 },
            { type: 15, value: 1 },
            { type: 16, value: 1 },
            { type: 17, value: 1 },
            { type: 18, value: 1 },
            { type: 20, value: 1 }
          )

          console.log(this.formData.config[index].event)
          break

        case 19:
          this.formData.config[index].event.push(
            { type: 1, value: 1 },
            { type: 2, value: 1 },
            { type: 15, value: 1 },
            { type: 19, value: 1 },
            { type: 27, value: 1 },
            { type: 28, value: 1 },
            { type: 29, value: 1 }
          )
          break
        case 5:
        case 6:
        case 7:
        case 8:
        case 9:
        case 10:
        case 11:
        case 12:
          this.formData.config[index].event.push({
            type: val,
            value: 1
          })
          break

        case 23:
          this.formData.config[index].event.push({
            type: 3,
            value: 1
          })
          this.formData.config[index].event.push({
            type: 4,
            value: 1
          })

          break

        case 18:
          this.formData.config[index].event.push({
            type: 20,
            value: 1
          })
          break

        case 21:
          this.formData.config[index].event.push({
            type: 21,
            value: 1
          })
          break

        case 16:
          this.formData.config[index].event.push({
            type: 22,
            value: 1
          })
          break

        case 20:
          this.formData.config[index].event.push({
            type: 23,
            value: 1
          })
          break

        case 17:
          this.formData.config[index].event.push({
            type: 24,
            value: 1
          })
          break

        case 22:
          this.formData.config[index].event.push({
            type: 25,
            value: 1
          })
          break

        case 24:
          this.formData.config[index].event.push({
            type: 3,
            value: 1
          }, {
            type: 4,
            value: 1
          })
          break
      }
    },
    handleClose(d) {
      this.drawer = false
    },
    handleClose2(d, index) {
      this.drawerArr[index].visible = false
    },
    addCfg() {
      this.formData.config.push(
        { type: 1, event: [] },
        { type: 23, event: [] },
        { type: 5, event: [] },
        { type: 6, event: [] },
        { type: 7, event: [] },
        { type: 8, event: [] },
        { type: 9, event: [] },
        { type: 10, event: [] },
        { type: 11, event: [] },
        { type: 12, event: [] },
        { type: 3, event: [] },
        { type: 19, event: [] },
        { type: 18, event: [] },
        { type: 21, event: [] },
        { type: 16, event: [] },
        { type: 20, event: [] },
        { type: 17, event: [] },
        { type: 22, event: [] },
        { type: 24, event: [] }
      )
      for (const i in this.formData.config) {
        const val = this.formData.config[i]
        this.typeChange(val.type, i)
        this.drawerArr.push({ visible: false })
      }
    },
    delCfg(idx) {
      this.formData.config = this.formData.config.filter((item, index) => {
        return idx !== index
      })
    },
    edit(row) {
      this.drawerArr = []
      row.config.forEach(res => {
        this.drawerArr.push({ visible: false })
      })

      this.formData = row
      this.drawer = true
    },
    onSubmit() {
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          if (!this.formData.name) {
            this.msgError('请输入名称')
            return false
          }
          if (this.formData.config.length <= 0) {
            this.msgError('请添加事件')
            return false
          }
          const data = JSON.stringify(this.formData)

          updateSlotTestCfgCfg({ data: data }).then(res => {
            if (res.code === 200) {
              this.drawer = false
              this.formData = this.formDataBak
              this.msgSuccess(res.msg)
              this.getTables()
            } else {
              this.msgError(res.msg)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    getChessBoardType() {
      getChessBoardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.selectType.push({ 'label': res.data[i], 'value': parseInt(i) })
          }
        }
      })
    },
    getType() {
      getSlotTestType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.chessType.push({ 'label': res.data[i], 'value': parseInt(i) })
          }
        }
      })
    },
    getTables() {
      this.loading = true
      getSlotTestCfgList(this.queryParams).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.tableData = res.data.list
          this.total = res.data.count
        } else {
          this.msgError(res.msg)
        }
      })
    },
    add() {
      this.drawer = true
    },
    del(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delSlotTestCfgList({ id: id }).then(res => {
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.getTables()
          } else {
            this.msgError(res.msg)
          }
        })
      })
    },
    getMood(row, idx) {
      const len = row.length
      console.log('len', len, idx)
      if (idx >= len) {
        return '-'
      }

      const event = row[idx].event
      const arr = []
      for (const i in event) {
        const val = event[i]
        arr.push(val.value)
      }
      return arr.join(';')
    }
  }
}
</script>

<style scoped>
</style>
